export default __webpack_public_path__ + "static/media/fsharp.3dc8f865.svg";